import React, { useState, useEffect } from 'react';
import MonacoEditor from 'react-monaco-editor';
import * as monaco from 'monaco-editor';

interface JsonEditorProps {
    initialJson: any;
    onChange: (json: any) => void;
}

const JsonEditor: React.FC<JsonEditorProps> = ({ initialJson, onChange }) => {
    const [jsonString, setJsonString] = useState(JSON.stringify(initialJson, null, 2));

    // useEffect(() => {
    //     monaco.editor.defineTheme('myCustomTheme', {
    //         base: 'vs', // can also be vs-dark or hc-black
    //         inherit: true, // can also be false to completely define all colors
    //         rules: [
    //             { token: 'number', foreground: 'af6e00' },
    //             { token: 'type.identifier', foreground: '267f99' },
    //             { token: 'string', foreground: '008000' },
    //             { token: 'keyword', foreground: '0000ff' },
                
    //         ],
    //         colors: {
    //             'editor.foreground': '#000000',
    //             'editor.background': '#EDF9FA',
    //             'editorCursor.foreground': '#8B0000',
    //             'editor.lineHighlightBackground': '#0000FF20',
    //             'editorLineNumber.foreground': '#008800',
    //             'editor.selectionBackground': '#88000030',
    //             'editor.inactiveSelectionBackground': '#88000015'
    //         }
    //     });
    // }, []);

    const editorOptions = {
        selectOnLineNumbers: true,
        roundedSelection: false,
        readOnly: false,
        cursorStyle: 'line',
        automaticLayout: true,
        theme: 'light',
        language: 'json',
        formatOnPaste: true,
        formatOnType: true
    };

    const handleEditorChange = (newValue: string, e: any) => {
        setJsonString(newValue);
        try {
            const json = JSON.parse(newValue);
            onChange(json); // Only emit valid JSON
        } catch (error) {
            // Optionally handle JSON parse errors or propagate them up
        }
    };

    return (
        <MonacoEditor
            width="100%"
            height="600px"
            language="json"
            theme="light"
            value={jsonString}
            // options={editorOptions}
            onChange={handleEditorChange}
        />
    );
};

export default JsonEditor;
